export enum AppRoutes {
  NOT_AUTHORIZED_PAGE = 'not-authorized',
  MODULE_LIBRARY_WORKBENCH_PAGE = 'module-library-workbench',
  MODULE_GROUPS_WORKBENCH_PAGE = 'module-groups-workbench',
  MODULE_EXECUTOR_WORKBENCH_PAGE = 'module-executor-workbench',
  DATA_EXTRACTION_PAGE = 'data-extraction',
  MODULE_GROUP_MANAGEMENT_PAGE = 'module-group-management',
}
